import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PublicLayout from "./pages/site/PublicLayout";
import Home from "./pages/site/Home";
import PageView from "./pages/site/PageView";
import TrainingDetail from "./pages/site/TrainingDetail";
import ServiceDetail from "./pages/site/ServiceDetail";
import { PressDetail } from "./pages/site/Press";
import { NewsList, NewsDetail } from "./pages/site/News";
import { Videos, AlbumView, VideoView, Gallery, GalleryAlbum } from "./pages/site/Media";
import Contact from "./pages/site/Contact";
import NotFound from "./pages/site/NotFound";
import AdminApp from "./pages/admin/AdminApp";
import { SEG } from "./lib/i18n";

// Hostname'den paneli kimin gördüğüne karar veriyoruz.
//  • wsp.olgu.eu    → subdomain'in kendisi "workspace paneli" demek: kök
//                     ziyaretler doğrudan /admin'e redirect eder, URL
//                     wsp.olgu.eu/admin/... formunda akar.
//  • Diğer tüm hostlar (olgu.eu, www, preview, dev dahil) → /admin açık kalır.
//    (wsp.olgu.eu Emergent tarafından aktifleştirildiğinde bu dosyada ADMIN_ALLOWED
//    sadece subdomain + preview olacak şekilde kısıtlayabiliriz.)
const _host = (typeof window !== "undefined" ? window.location.hostname : "").toLowerCase();
const IS_WSP_SUBDOMAIN = _host.startsWith("wsp.");

const publicRoutes = (lang) => {
  const s = SEG[lang];
  return [
    <Route key="i" index element={<Home />} />,
    <Route key="n" path={s.news} element={<NewsList />} />,
    <Route key="nd" path={`${s.news}/:slug`} element={<NewsDetail />} />,
    <Route key="v" path={s.videos} element={<Videos />} />,
    <Route key="vd" path={`${s.videos}/:slug`} element={<AlbumView />} />,
    <Route key="vv" path={`${s.videos}/${s.watch}/:slug`} element={<VideoView />} />,
    <Route key="g" path={s.gallery} element={<Gallery />} />,
    <Route key="gd" path={`${s.gallery}/:slug`} element={<GalleryAlbum />} />,
    <Route key="c" path={s.contact} element={<Contact />} />,
    <Route key="td" path="egitimlerim/:slug" element={<TrainingDetail />} />,
    <Route key="sd" path="calismalarim/:slug" element={<ServiceDetail />} />,
    <Route key="pd" path="basin-arsivi/:slug" element={<PressDetail />} />,
    <Route key="p" path=":slug" element={<PageView />} />,
    <Route key="x" path="*" element={<NotFound />} />,
  ];
};

function App() {
  // On the admin subdomain the public site must never be reachable — not
  // even accidentally through a route-matching tie — so we register ONLY
  // the admin routes there. React Router v6 was treating the public
  // layout's `path="/"` (which has child routes) as more specific than the
  // sibling `path="/"` Navigate, so visiting wsp.olgu.eu kept rendering the
  // public homepage. Branching the <Routes> tree makes the intent explicit.
  return (
    <BrowserRouter>
      <Routes>
        {IS_WSP_SUBDOMAIN ? (
          <>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </>
        ) : (
          <>
            <Route path="/admin/*" element={<AdminApp />} />
            <Route path="/en" element={<PublicLayout lang="en" />}>{publicRoutes("en")}</Route>
            <Route path="/" element={<PublicLayout lang="tr" />}>{publicRoutes("tr")}</Route>
          </>
        )}
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
